// extracted by mini-css-extract-plugin
module.exports = {"fieldOfStudySection":"styles_fieldOfStudySection__HId19"};